import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
const app = createApp(App);

import eventBus from 'vue3-eventbus'
app.use(eventBus)

import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'

import "@/assets/style.scss"

import * as ElementPlusIconsVue from '@element-plus/icons-vue'

for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
    app.component(key, component)
}

var Avatar = require('vue-avatar')
app.component(Avatar)



app.use(store)
app.use(router)
app.use(ElementPlus)
app.mount('#app')
